import React, { useState } from "react";
import "./PassReset.css";
import { resetPassword } from "../../api/api";
import visibleHide from "../../assets/images/visibility_hide.png";
import visibleShow from "../../assets/images/visibility_show.png";
import loader from "../../assets/images/loader.gif";

export default function PassReset(props) {
  const openApp = () => {
    window.location = "com.searates-connect://";
  };

  const [loading, setLoading] = useState(false);
  const [resetStatus, setResetStatus] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [errorPass, setErrorPass] = useState(false);
  const [errorConfirmPass, setErrorConfirmPass] = useState(false);
  const [passErrorText, setPassErrorText] = useState("");
  const [passConfirmErrorText, setPassConfirmErrorText] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const checkPass = (e) => {
    e.target.value === confirmPassword
      ? setErrorConfirmPass(false)
      : setErrorConfirmPass(true);
    if (e.target.value.length < 8) {
      setPassErrorText("Password should contain atleast 8 characters");
      setErrorPass(true);
    } else {
      setErrorPass(false);
      setPassword(e.target.value);
    }
  };

  const confirmPass = (e) => {
    console.log(e.target.value);
    if (e.target.value !== password) {
      setErrorConfirmPass(true);
      setPassConfirmErrorText("Password and Confirm Password doesn't match");
    } else {
      setErrorConfirmPass(false);
    }
    setConfirmPassword(e.target.value);
  };

  const submitPass = () => {
    if (password.length < 8) {
      setPassErrorText("Password should contain atleast 8 characters");
      setErrorPass(true);
      setResetStatus(false);
    } else if (!errorPass && !errorConfirmPass) {
      setLoading(true);
      resetPassword(props.token, password)
        .then((res) => {
          if (res.data.code === 200) setResetStatus(true);
          else setResetStatus(false);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setResetStatus(false);
          setLoading(false);
        });
    }
  };

  if (loading)
    return (
      <div className="align-center align-center-pass-reset">
        <img src={loader} alt="loading..." className="loader" />
      </div>
    );
  else
    return (
      <div className="align-center align-center-pass-reset">
        <div className="verification-box">
          <div
            className={
              resetStatus
                ? "success-icon"
                : props.success
                ? "lock-icon"
                : "fail-icon"
            }
          />
          <div className="verification-text">
            {resetStatus ? (
              <>
                <h1>Password Changed</h1>
                <h2>
                  Thank you for your support, we have successfully changed your
                  password.
                </h2>
              </>
            ) : props.success ? (
              <>
                <h1>Reset New Password</h1>
                <div>
                  <input
                    type={showPass ? "text" : "password"}
                    placeholder="New Password"
                    className="password"
                    onChange={checkPass}
                  />
                  <i
                    className="showpass"
                    onClick={() => setShowPass(!showPass)}
                  >
                    <img
                      src={showPass ? visibleShow : visibleHide}
                      alt="visible hide icon"
                      className="pass-icon"
                    />
                  </i>
                  <p className="error-text">
                    {errorPass ? passErrorText : " "}
                  </p>
                </div>
                <div>
                  <input
                    type={showConfirmPass ? "text" : "password"}
                    placeholder="Confirm Password"
                    className="password"
                    onChange={confirmPass}
                  />
                  <i
                    className="showpass"
                    onClick={() => setShowConfirmPass(!showConfirmPass)}
                  >
                    <img
                      src={showConfirmPass ? visibleShow : visibleHide}
                      alt="visible hide icon"
                      className="pass-icon"
                    />
                  </i>
                  <p className="error-text">
                    {errorConfirmPass ? passConfirmErrorText : " "}
                  </p>
                </div>
              </>
            ) : (
              <>
                <h1>Invalid Link</h1>
                <h2>
                  The password reset link is invalid or expired. Please
                  re-generate the link from app.
                </h2>
              </>
            )}
            {resetStatus || !props.success ? (
              <button className="button" onClick={openApp}>
                OPEN APP
              </button>
            ) : (
              <button className="button" onClick={submitPass}>
                SUBMIT
              </button>
            )}
          </div>
        </div>
      </div>
    );
}
